import { formName } from '../Constants/constants';

export const getHasKentuckyFormErrors = (state) => {
  const errors = state.form[formName].syncErrors;
  return Boolean(errors?.federalEntity || errors?.kentuckyStateEntity);
};
